export default __webpack_public_path__ + "static/media/hango-screenshot-05.dfd7f98a.png";